import { executeUpsellSlotAction } from '#pplx/frontend/apps/ask/upsell-slots/actions/internal/executeUpsellSlotAction.js';
import { useCallback } from 'react';
export const useExecuteUpsellSlotAction = ({ inFlight, options = {}, runtime, upsellInformation, }) => {
    const { customHandlers, interactionType, onCreditsPurchased } = options;
    return useCallback((selectedActionOptionId) => executeUpsellSlotAction({
        customHandlers,
        selectedActionOptionId,
        inFlight,
        interactionType,
        onCreditsPurchased,
        runtime,
        upsellInformation,
    }), [customHandlers, inFlight, interactionType, onCreditsPurchased, runtime, upsellInformation]);
};
//# sourceMappingURL=useExecuteUpsellSlotAction.js.map